import apiRoutes from "../../Routes/Routes.json";
import HttpClient from "HttpClient";

export const getAllData = (parameter: any) => {
  return HttpClient().post(
    `${apiRoutes.BloodLis.ReferenceTests.GetAllReferenceTests}`,
    parameter
  );
};



export const RejectBloodLISReferenceTest= (parameter: any) => {
  return HttpClient().post(
    `${apiRoutes.BloodLis.ReferenceTests.RejectBloodLISReferenceTest}`,
    parameter
  );
};





export const UploadBloodReferenceTestResultPdf= (object:any) => {
  return HttpClient().post(
    `${apiRoutes.BloodLis.ReferenceTests.UploadBloodReferenceTestResultPdf}`,
    object
  );
};


export const ReferenceTestsExportToExcel= (parameter: any) => {
  return HttpClient().post(
    `${apiRoutes.BloodLis.ReferenceTests.ReferenceTestsExportToExcel}`,
    parameter
  );
};


export const  SaveReferenceTestInternalNote = (parameter: any) => {
  return HttpClient().post(
    `${apiRoutes.BloodLis.ReferenceTests.SaveReferenceTestInternalNote}`,
    parameter
  );

}


export const  GetReferenceTestInternalNote = (LISResultDataId : any) => {
  return HttpClient().post(
    `${apiRoutes.BloodLis.ReferenceTests.GetInternalNotesByLISResultDataId}/${LISResultDataId}`
  );

}
